<template>
	<div class="ewallet">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0 text-gray mt-3 mt-md-0">
					<ml-menu></ml-menu>
					<div class="col-12 p-0 pb-3">
						<div class="container p-0 p-md-2">
							<div class="row">
								<div class="col-12 col-md-6 mt-5 mt-md-5">
									<div class="col-md-12 d-md-flex pl-0 mt-2 pb-3">
										<div class="font-size-16 font-size-sm-12">Dana Penjualan</div>
									</div>
								</div>
								<div class="col-6 pr-0 col-md-6 mt-5 mt-md-5 d-none d-sm-block">
									<nav aria-label="breadcrumb">
										<ol class="breadcrumb float-right">
											<li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
											<li class="breadcrumb-item active" aria-current="page"><a href="javascript:;">Dana Penjualan</a></li>
										</ol>
									</nav>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-lg-7 col-md-10 mb-md-2">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12 col-md-6 p-0 d-flex pb-3 pl-3 pr-3 pr-md-1"  v-if="ewalletBalance === ''">
												<div class="col-12 p-0 pt-2 pb-2 background-white rounded cus-box-shadow">
													<vcl :width='400' :height='100'>
														<rect x="15" y="25" rx="2" ry="2" width="110" height="12" />  
														<rect x="15" y="48" rx="2" ry="2" width="230" height="33" />  
														<rect x="300" y="25" rx="4" ry="4" width="45" height="45" />
													</vcl>
												</div>
											</div>
											<div class="col-12 col-md-6 p-0 d-flex pb-3 pl-3 pr-3 pr-md-1" v-else>
												<div class="col-12 p-0 pt-2 pb-2 background-white rounded cus-box-shadow">
													<div class="row">
														<div class="col-8 col-md-8 pr-0 pt-2 pt-md-3 pb-1 pl-4 ml-2 font-size-11">
															<p class="mb-n1">Total Dana</p>
															<div class="text-purple font-size-16 font-size-sm-14">{{ ewalletBalance | toRupiah}}</div>
														</div>
														<div class="col-3 col-md-3 mt-auto mb-auto">
															<img class="img-fluid" src="assets/icon/icon-stok-produk.png">
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12 col-md-12 mb-2 mt-2">
									<div class="col-12 p-0 background-white rounded-top cus-box-shadow z-index-1">
										<div class="col-12 p-0 d-flex pt-3 pl-4">
											<div class="col-12 p-0">
												<div class="row">
													<div class="col-6 col-md-6 font-size-sm-11">
														<p>Mutasi Dana</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 p-0 background-gray-light rounded-bottom cus-box-shadow">
										<a class="text-gray" data-toggle="collapse" href="#collapseFilterStokSerial" role="button" aria-expanded="false" aria-controls="collapseExample">
											<div class="col-12 p-0 d-flex pt-3 pl-4 pb-2">
												<div class="col-12 p-0">
													<div class="row font-size-sm-10 font-size-12">
														<div class="col-12 col-md-12 mt-n1">
															<img src="assets/icon/filter.png" class="pr-1">Filter
														</div>
													</div>
												</div>
											</div>
										</a>
										<div class="col-12 col-md-12 mt-1 font-size-sm-10 font-size-11 collapse" id="collapseFilterStokSerial">
											<div class="row pb-3">
												<div class="col-12 col-lg-5 col-md-8 pt-2 pt-md-0">
													<div class="row">
														<div class="col-4 col-lg-4 col-md-3 mt-1 pl-4">
															<span>Tanggal</span>
														</div>
														<div class="col-4 col-lg-4 col-md-4 pl-0 pr-2">
															<datepicker :language="indonesia" input-class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple fullscreen-when-on-mobile" v-model="tanggalAwal" placeholder="Dari Tanggal" bootstrap-styling>
															</datepicker>
														</div>
														<div class="col-4 col-lg-4 col-md-4 pl-0 pr-2">
															<datepicker :language="indonesia" input-class="form-control font-size-sm-8 font-size-9 form-control-sm text-gray box-purple fullscreen-when-on-mobile" v-model="tanggalAkhir" placeholder="Sampai Tanggal" bootstrap-styling>
															</datepicker>
														</div>
													</div>
												</div>
												<div class="col-8 offset-4 col-lg-4 col-md-4 offset-md-0 offset-lg-0 pt-2 pl-md-0 pl-lg-3 pt-md-0 pl-0 pr-0 pr-md-3">
													<div class="col-md-12 pl-0 pr-2 d-flex">
														<div class="col-6 col-lg-4 pl-0 pr-0">
															<button class="col-12 btn btn-mila btn-cari text-white font-size-10 font-size-sm-8 pt-1 pb-1 box-purple" @click="resetData()">Reset</button>
														</div>
														<div class="col-6 col-lg-4 pl-2 pr-0">
															<button class="col-12 btn btn-mila btn-cari text-white font-size-10 font-size-sm-8 pt-1 pb-1 box-purple" @click="cari()">Cari</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<div class="col-12 p-0">
										<div class="row" v-show="ewalletHistoryResults.length == 0">
											<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3" v-for="(index) in 2" :key="index">
												<div class="col-12 p-0 pt-2 pb-3 background-white rounded cus-box-shadow font-size-10 font-size-sm-9">
													<vcl :width='300' :height='15'>
														<rect x="6" y="3" rx="2" ry="2" width="25" height="4" />
														<rect x="75" y="3" rx="1" ry="1" width="5" height="4" />
														<rect x="80" y="3" rx="2" ry="2" width="25" height="4" />
														<rect x="140" y="3" rx="2" ry="2" width="30" height="4" />
														<rect x="200" y="3" rx="2" ry="2" width="32" height="4" />
														<rect x="6" y="10" rx="2" ry="2" width="40" height="4" />
														<rect x="75" y="10" rx="1" ry="1" width="5" height="4" />
														<rect x="80" y="10" rx="2" ry="2" width="20" height="4" />
														<rect x="135" y="10" rx="2" ry="2" width="35" height="4" />
														<rect x="200" y="10" rx="2" ry="2" width="85" height="4" />
													</vcl>
												</div>
											</div>
										</div>
										<div class="row" v-if="ewalletHistoryResults == 'error'">
											<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3">
												<div class="col-12 p-0 pb-2 background-white rounded cus-box-shadow">
													<div class="col-12 p-0 d-flex pb-2 pl-4">
														<div class="col-12 p-0">
															<div class="row">
																<div class="col-md-12 col-12 mt-1 text-center">
																	<img src="assets/icon/stock_empty.svg" width="100px;" class="mt-n3">
																	<p class="mb-n1 font-size-sm-11 font-size-12">Data Tidak Tersedia</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="row" v-else>
											<div class="col-12 col-md-12 p-0 d-flex pb-2 pl-3 pr-3" v-for="(value, index) in ewalletHistoryResults" :key="index">
												<div class="col-12 p-0 pt-2 pb-3 background-white rounded cus-box-shadow font-size-10 font-size-sm-9">
													<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
														<div class="col-12 col-md-4 col-lg-3 mt-3">
															<div>Tanggal</div>
															<div class="pt-1"><img src="assets/icon/kalendar_color.png" class="img-fluid mt-n1 pr-1"><span> {{ value.ewallet_log_datetime | tanggaljam }}</span></div>
														</div>
														<div class="col-12 col-lg-3 col-md-5 pt-3 pl-md-1">
															<div v-if="value.ewallet_log_in != 0"><img src="assets/icon/serial_in.png" class="img-fluid mt-n1 pr-1"><span>Dana Masuk</span><span class="float-right">{{ value.ewallet_log_in | toRupiah}}</span></div>
															<div v-if="value.ewallet_log_out != 0"><img src="assets/icon/serial_out.png" class="img-fluid mt-n1 pr-1"><span>Dana Keluar</span><span class="float-right">{{ value.ewallet_log_out | toRupiah}}</span></div>
															<div><img src="assets/icon/dompet.png" class="img-fluid mt-n1 pr-1"><span>Dana Akhir</span><span class="float-right">{{ value.ewallet_log_balance | toRupiah}}</span></div>
														</div>
														<div class="col-12 offset-lg-1 col-lg-5 pt-3 pl-lg-0">
															<div>Keterangan</div>
															<div class="pt-1"><span>{{ value.ewallet_log_note }} </span></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- pagination -->
							<div class="row" v-if="ewalletHistoryPagination && ewalletHistoryResults.length > 0" >
								<div class="col-12 col-md-12 mt-3">
									<div class="col-12 p-0">
										<div class="row">
											<div class="col-12 col-md-12">
												<div class="row">
													<div class="col-9 offset-1 col-md-12 ml-0 ml-md-0">
														<ul class="pagination float-md-left">
															<li v-if="ewalletHistoryPagination.first_page == true" @click="pagination(ewalletHistoryPagination.current==1)">
																<a class="page-link background-mila rounded-left" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png"></span>
																</a>
															</li>
															<li v-if="ewalletHistoryPagination.prev>=1" @click="pagination(ewalletHistoryPagination.prev)">
																<a class="page-link background-mila" href="#" aria-label="Previous">
																	<span aria-hidden="true"><img src="assets/icon/back.png"></span>
																</a>
															</li>
															<li @click="pagination(page)" v-for="(page,index) in ewalletHistoryPagination.detail" :key="index"><span class="page-link text-purple" :class="{active:page==ewalletHistoryPagination.current}" >{{ page }}</span></li>
															<li v-if="ewalletHistoryPagination.next!=0" @click="pagination(ewalletHistoryPagination.next)">
																<a class="page-link background-mila" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
															<li v-if="ewalletHistoryPagination.last_page==true" @click="pagination(ewalletHistoryPagination.total_page)">
																<a class="page-link background-mila rounded-right" href="#">
																	<span aria-hidden="true"><img src="assets/icon/back_dobel.png" style="transform: rotateY(180deg);"></span>
																</a>
															</li>
														</ul>
														<ul class="pagination float-md-right" :class="[ewalletHistoryPagination.total_page==1 || ewalletHistoryPagination.total_page==0  ? 'mt-md-4 mt-lg-0' : 'mt-md-n2 mt-lg-0']">
															<li @click="pagination(ewalletHistoryPagination.current)">
																<a class="page-link background-mila rounded text-white" href="#" aria-label="Previous">
																	<span aria-hidden="true" class="font-size-10"><img src="assets/icon/refresh.png" class="pr-1">Refresh</span>
																</a>
															</li>
															<li class="">
																<div class="btn-group">
																	<button type="button" class="btn btn-outline-purple dropdown-toggle background-white box-purple" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{tanggal.limit}}
																		<div class="dropdown-menu pagi-dropdown">
																			<span class="dropdown-item text-gray" v-for="(limit, index) in limit" :key="index" @click="getLimit(limit)">{{limit}}</span>
																		</div>
																	</button>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
	name: 'Ewallet',
	components : {
		Datepicker,
	},
	data () {
		return {
			tanggal:{
				value:'',
				comparison:'bet',
				type:'date',
				field:'ewallet_log_datetime',
				limit:10
			},
			tanggalAwal:'',
			tanggalAkhir:'',
			paramLimit: '',
			paramPage: '',
			paramStatus:'',
			currentLimit: 10,
			limit: [5, 10, 20, 50, 100, 200],
		}
	},
	computed: {
		...mapState('getEwallet', ['ewalletBalance', 'ewalletHistoryPagination', 'ewalletHistoryResults']),
		...mapGetters('auth', ['isAuth']),
	},
	methods: {
		...mapActions('getEwallet', ['getBalance', 'getHistory', 'filter']),
		pagination(val) {
			this.tanggal.page = val
			this.filter(this.tanggal)
		},
		getLimit(limit) {
			this.tanggal.limit = limit
			this.filter(this.tanggal)
		},
		cari() {
			if(!this.tanggalAkhir) {
				this.tanggalAkhir = this.tanggalAwal
			}
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
			}
			this.filter(this.tanggal)
		},
		resetData() {
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.tanggal.value = ''
			this.tanggal.limit = 10
			this.filter(this.tanggal)
		},
	},
	created () {
		this.getBalance();
		this.getHistory({limit: this.tanggal.limit, page: ''});
		this.$store.dispatch('setPageTitle', `Dana Penjualan`);
	}
}
</script>

<style>
.page-link.active {
	z-index: 2;
	color: #0056b3;
	text-decoration: none;
	background-color: #e9ecef;
	border-color: #dee2e6;
}
</style>